module.exports = __webpack_public_path__ + "img/product-insurance-2.12414b18.png";